/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?:string;
};

const SvgComponent: FC<IProps> = ({ fill="#262626", width = 15, height = 15 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M6.725 14.4136L0.275 7.93861C0.175 7.85527 0.104334 7.75927 0.0630002 7.65061C0.0210002 7.54261 0 7.43027 0 7.31361C0 7.19694 0.0210002 7.08427 0.0630002 6.97561C0.104334 6.86761 0.175 6.77194 0.275 6.68861L6.725 0.213608C6.875 0.0802746 7.05 0.00927426 7.25 0.000607593C7.45 -0.00739241 7.625 0.0636079 7.775 0.213608C7.925 0.363608 8.004 0.538608 8.012 0.738608C8.02067 0.938608 7.95 1.12194 7.8 1.28861L2.5 6.56361H14.125C14.325 6.56361 14.5 6.63427 14.65 6.77561C14.8 6.91761 14.875 7.09694 14.875 7.31361C14.875 7.53027 14.8 7.70927 14.65 7.85061C14.5 7.99261 14.325 8.06361 14.125 8.06361H2.5L7.8 13.3636C7.93333 13.4969 8.004 13.6676 8.012 13.8756C8.02067 14.0843 7.95 14.2636 7.8 14.4136C7.65 14.5636 7.471 14.6386 7.263 14.6386C7.05433 14.6386 6.875 14.5636 6.725 14.4136Z" fill={fill}/>
  </svg>
);

export default SvgComponent;
